import React from "react"
import { Box, Grid, Typography } from "@mui/material"
import { ModalSeeker } from "@ui-seeker/core"
import { sitesModalData } from "@signals"
import ModalCountriesSelector from "./Countries"
import useSiteModalFilter from "./@hooks"
import { AppRetailerBlock } from "@components/DataBlocks/index"
import ModalSitesSelector from "./Sites"


export default function AppSitesModal({ ...props }) {

	const {
		filteredList,
		filteredSites,
		onChangeSite,
		onChangeCountry,
		countriesOptions,
		applyFilters
	} = useSiteModalFilter()

	return <ModalSeeker
		isOpen={!!sitesModalData.value?.length}
		controller={() => sitesModalData.value = []}
		title="Sites List"
		hideActions
		{...props?.modalProps}
	>
		<Grid container spacing={2}>
			<Grid item xs={4}>
				<ModalSitesSelector
					applyFilters={applyFilters}
					filteredSites={filteredSites}
					onChangeSite={onChangeSite}
				/>
			</Grid>
			<Grid item xs={4}>
				<ModalCountriesSelector
					applyFilters={applyFilters}
					countriesOptions={countriesOptions}
					onChangeCountry={onChangeCountry}
				/>
			</Grid>
			<Grid item xs={12}>
				{!!filteredList.length && <Box sx={{
					display: "flex",
					alignItems: "start",
					justifyContent: "start",
					flexDirection: "column",
					flexWrap: "wrap",
					height: "30vh",
					...props.containerProps
				}}>
					{filteredList.map(({ name, market }, idx) => (
						<AppRetailerBlock
							key={`${name}-${idx}`}
							retailer={name}
							country={market}
							sx={{ m: .5 }}
							{...props.sitesProps}
						/>
					))}

				</Box>}
				{!filteredList.length && <Box sx={{
					display: "flex",
					alignItems: "start",
					justifyContent: "center",
					height: "30vh",
					p: 1
				}}>
					<Typography variant="caption">No results for the given filters</Typography>
				</Box>}
			</Grid>
		</Grid>
	</ModalSeeker>
}